module.exports = __webpack_public_path__ + "static/media/IMG_8218_cropped3.52f121f2.jpg";